// extracted by mini-css-extract-plugin
export default {"image-container":"image-upload_image-container__8wOOz"};